import { POSTER_ASPECT, POSTER_CSS_WIDTH, sizedImageUrl, useSizedBackground } from "../lib/imageUrl.js";

/**
 * The shared "film frame" backdrop for a cinematic band: a blurred, scaled
 * cover image under a grain overlay and a vignette + bottom legibility wash.
 * Purely decorative (aria-hidden) — the band's real content renders above it
 * with position:relative;z-index:1. When there is no cover the grain/scrim
 * still render, so an image-less band reads intentional.
 */
export function CineBackdrop({ cover }: { cover: string | null }) {
  // The same variant as the film cards and the novel poster, so the page that
  // shows a backdrop already has it cached; a 26px blur hides the crop.
  const backdrop = useSizedBackground(cover, sizedImageUrl(cover, POSTER_CSS_WIDTH, { aspect: POSTER_ASPECT }));
  return (
    <div className="cine-fx" aria-hidden="true">
      {cover && (
        <div className="cine-backdrop" style={{ backgroundImage: `url(${backdrop})` }} />
      )}
      <div className="cinema-grain" />
      <div className="cine-scrim" />
    </div>
  );
}
